import { appListenerMiddleware } from 'reduxTyped'
import { fetchSubscribers } from 'common/audience/actions/audienceThunks'
import { getCurrentPage } from 'utils/url'

import { setSystemFieldValue } from './userFieldsActions'

// Listen to setSystemFieldValue success and refresh subscribers list if on audience page
appListenerMiddleware.startListening({
  matcher: setSystemFieldValue.fulfilled.match,
  effect: (_, { dispatch }) => {
    const currentPage = getCurrentPage()

    if (currentPage === 'subscribers') {
      dispatch(fetchSubscribers())
    }
  },
})
